import React from 'react';
import {
  MilitaryTech,
  PermIdentity,
  PostAdd,
  Source,
} from '@mui/icons-material';
import './profileLayout.css';
import GlobalSidebar from '../GlobalSidebar/GlobalSidebar';
const iconSx = { color: '#ffffff' };

const manageTabList = [
  {
    title: 'My Benefits',
    tabs: [
      {
        iconSource: <PermIdentity sx={iconSx} />,
        title: 'My Benefits',
        navigateTo: '/benefits/mybenefits',
        bgColor: '#FF9201',
      },
      {
        iconSource: <PostAdd sx={iconSx} />,
        title: 'Add Beneficiary',
        navigateTo: '/my-benefits/benefits-available',
        bgColor: '#FF9201',
      },
      {
        iconSource: <Source sx={iconSx} />,
        title: 'Beneficiary Details',
        navigateTo: '/my-benefits/benefits-summary',
        bgColor: '#FF9201',
      },
      {
        iconSource: <MilitaryTech sx={iconSx} />,
        title: 'Rewards',
        bgColor: '#FF9201',
        showOptions: true,
        lastTab: true,
        options: [
          {
            title: 'My Rewards',
            navigateTo: '/benefits/rewards',
            bgColor: '#FF9201',
          },
          {
            title: 'My Network Rewards',
            navigateTo: '/benefits/network-rewards',
            bgColor: '#FF9201',
          },
        ],
      },
    ],
  },
];

const MyBenefitSideBar = () => {
  return <GlobalSidebar sections={manageTabList} />;
};

export default MyBenefitSideBar;
